import { render, staticRenderFns } from "./approvalItemEdit.vue?vue&type=template&id=6a141886&scoped=true&"
import script from "./approvalItemEdit.vue?vue&type=script&lang=js&"
export * from "./approvalItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./approvalItemEdit.vue?vue&type=style&index=0&id=6a141886&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a141886",
  null
  
)

export default component.exports